import { render, staticRenderFns } from "./ord_suite.vue?vue&type=template&id=240f500f&scoped=true&"
import script from "./ord_suite.vue?vue&type=script&lang=js&"
export * from "./ord_suite.vue?vue&type=script&lang=js&"
import style0 from "./ord_suite.vue?vue&type=style&index=0&id=240f500f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f500f",
  null
  
)

export default component.exports